import type { ReactElement } from "react";
import KycLayout from "../layouts/KycLayout";
import KycVerification from "../pages/KycVerification";
import KycVerificationSuccess from "../pages/KycVerificationSuccess";
import KycVerificationRejected from "../pages/KycVerificationRejected";
import KycVerificationPending from "../pages/KycVerificationPending";
import KycFormPage from "../pages/KycFormPage";
import KycMembershipGuard from "../components/KycMembershipGuard";

const withKycMembershipGuard = (page: ReactElement) => (
  <KycMembershipGuard>
    <KycLayout>{page}</KycLayout>
  </KycMembershipGuard>
);

const kycRoutes = [
  {
    path: "/kyc-verification",
    element: withKycMembershipGuard(<KycVerification />),
  },
  {
    path: "/kyc-verification/form",
    element: withKycMembershipGuard(<KycFormPage />),
  },
  {
    path: "/kyc-verification-success",
    element: withKycMembershipGuard(<KycVerificationSuccess />),
  },
  {
    path: "/kyc-verification-rejected",
    element: withKycMembershipGuard(<KycVerificationRejected />),
  },
  {
    path: "/kyc-verification-pending",
    element: withKycMembershipGuard(<KycVerificationPending />),
  },
];

export default kycRoutes;
